import { useSearchParams } from 'react-router-dom'

/**
 * The side panel a management page has open, kept in the URL (`?client=new` or `?client=<id>`)
 * so it survives reloads and the back button closes it.
 */
export function usePanelParam(key: string): [string | null, (value: string | null) => void] {
  const [searchParams, setSearchParams] = useSearchParams()

  function openPanel(value: string | null): void {
    const next = new URLSearchParams(searchParams)
    if (value) next.set(key, value)
    else next.delete(key)
    setSearchParams(next, { replace: true })
  }

  return [searchParams.get(key), openPanel]
}
